import 'blueimp-file-upload';
import 'lightgallery';

$(() => {
  $('.lightGallery').lightGallery({
    selector: '.img-thumbnail'
  });

  // image upload
  $('.fileupload').fileupload({
    url: $(this).data('url'),
    dataType: 'json',
    start (event) {
      let $input = $(event.target);

      $('.card-header.d-none').removeClass('d-none');

      $input.closest('.btn')
        .find('.fa')
        .removeClass('fa-upload')
        .addClass('fa-spin fa-circle-o-notch');
    },
    progressall (e, data) {
      let progress = parseInt(data.loaded / data.total * 100, 10);
      $('.progress .progress-bar').css('width', progress + '%');
    },
    done () { location.reload(); }
  });
});
